var _style, _path, _g, _g2, _defs, _path2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoloToken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 673.8 673.8",
    style: {
      enableBackground: "new 0 0 673.8 673.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000037665135445287161060000016983154424033816254_);}\n\t.st2{fill:url(#SVGID_00000062181928569392991270000016558596449398339253_);}\n\t.st3{fill:url(#SVGID_00000112608703626690009920000015620107561019022471_);}\n\t.st4{fill:url(#SVGID_00000124122910953938937070000010671399078377082258_);}\n\t.st5{fill:url(#SVGID_00000019673636688739491790000016744691887919229580_);}\n\t.st6{fill:url(#SVGID_00000070106368466683379860000010255886950809979280_);}\n\t.st7{fill:url(#SVGID_00000117642490199066552530000010055023146378094009_);}\n\t.st8{fill:url(#SVGID_00000129922796407705985290000010061526119595251637_);}\n\t.st9{fill:#FFFAE6;}\n\t.st10{fill:#001E42;}\n\t.st11{fill:#173F91;}\n\t.st12{clip-path:url(#SVGID_00000163793929203623493380000007763381003379853721_);}\n\t.st13{fill:#1C52BF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 37.1145,
    cy: 590.5099,
    r: 350.8844,
    gradientTransform: "matrix(1 0 0 -1 0 659.2048)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F48C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#0F48C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#0E47BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#093182"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M673.8,336.9c0,186.1-150.8,336.9-336.9,336.9S0,523,0,336.9S150.8,0,336.9,0S673.8,150.8,673.8,336.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080180628269204316260000015729786759742486154_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 695.1702,
    x2: 336.8909,
    y2: 93.1609,
    gradientTransform: "matrix(1 0 0 -1 0 675.8612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#445175",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0C3CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#28437B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#03349B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080180628269204316260000015729786759742486154_)"
    },
    d: "M0,336.9c0,120.2,63,225.8,157.8,285.4 H516c94.8-59.6,157.8-165.1,157.8-285.4S610.8,111.1,516,51.5H157.8C63,111.1,0,216.6,0,336.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125565261394699155160000005786169820868998315_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 257.4462,
    x2: 336.8909,
    y2: 865.8015,
    gradientTransform: "matrix(1 0 0 -1 0 675.8612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2E4B87",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0C3CA0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#28437B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#34559B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125565261394699155160000005786169820868998315_)"
    },
    d: "M0,336.9c0,85.8,32.1,164.1,84.9,223.5 h504.1c52.8-59.5,84.9-137.8,84.9-223.5s-32.1-164.1-84.9-223.5H84.9C32.1,172.8,0,251.1,0,336.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025404418619678108200000002230214497126574502_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 328.7845,
    x2: 336.8909,
    y2: 134.2231,
    gradientTransform: "matrix(1 0 0 -1 0 675.8612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#253D6E",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0A3285"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#203561"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B4680"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025404418619678108200000002230214497126574502_)"
    },
    d: "M0,336.9c0,50.1,11,97.7,30.6,140.5h612.6 c19.6-42.8,30.6-90.3,30.6-140.5s-11-97.7-30.6-140.5H30.6C11,239.2,0,286.8,0,336.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083772341709059140660000002596323706080378510_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.8909,
    y1: 265.3728,
    x2: 336.8909,
    y2: 596.6815,
    gradientTransform: "matrix(1 0 0 -1 0 675.8612)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3759A0",
      stopOpacity: 0.04
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4671,
    style: {
      stopColor: "#0E45BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8016,
    style: {
      stopColor: "#305194"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3C63B5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083772341709059140660000002596323706080378510_)"
    },
    d: "M0,336.9c0,29,3.7,57.2,10.6,84h652.6 c6.9-26.9,10.6-55,10.6-84c0-29-3.7-57.2-10.6-84H10.6C3.7,279.7,0,307.9,0,336.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000040555569727696513810000004995352898639178671_",
    cx: 211.5435,
    cy: 411.502,
    r: 471.6267,
    gradientTransform: "matrix(1 0 0 -0.9951 0 657.592)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2F65D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2837,
    style: {
      stopColor: "#235BD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5391,
    style: {
      stopColor: "#194CBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7827,
    style: {
      stopColor: "#1349BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1248BA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040555569727696513810000004995352898639178671_)"
    },
    d: "M310.1,4.4C136.6,17.9,0,162.4,0,338.6 s136.6,320.6,310.1,334.2c173.6-13.6,310.1-158,310.1-334.2S483.7,17.9,310.1,4.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000049902580369465355920000018434535017087221948_",
    cx: 319.3573,
    cy: 324.6134,
    r: 295.0087,
    gradientTransform: "matrix(1.0944 0 0 -1.1379 -39.3583 707.2384)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFCF8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    style: {
      stopColor: "#FFFCF8",
      stopOpacity: 0.05098
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0F0F0F",
      stopOpacity: 0.31
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049902580369465355920000018434535017087221948_)"
    },
    d: "M329.2,5.7c-12.7-1.7-25.5-1.7-38.2,0 C126.7,27.9,0,168.2,0,337.9s126.7,310,291.1,332.2c12.7,1.7,25.5,1.7,38.2,0c164.4-22.3,291.1-162.5,291.1-332.2 S493.6,27.9,329.2,5.7z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000094607406753691810990000005045854242563750076_",
    cx: 358.5642,
    cy: 354.6847,
    r: 425.8231,
    gradientTransform: "matrix(0.9342 0 0 -1.0316 -4.2834 664.5832)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#01348F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3227,
    style: {
      stopColor: "#0F4AC7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    style: {
      stopColor: "#01348F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01348F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094607406753691810990000005045854242563750076_)"
    },
    d: "M558.8,334.7C558.8,179.7,445,54,304.7,54 C164.3,54,50.5,179.7,50.5,334.7s113.8,280.7,254.2,280.7C445,615.3,558.8,489.7,558.8,334.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169532468105910916840000018211030359630797963_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.0363,
    y1: 266.9846,
    x2: -14.5172,
    y2: 608.1282,
    gradientTransform: "matrix(1 0 0 -0.9901 0 654.5289)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#173F91"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7547,
    style: {
      stopColor: "#1F5AD4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169532468105910916840000018211030359630797963_)"
    },
    d: "M377,65.7c-34.6-10-71.5-10-106.1,0 C154.7,99.3,69.5,207.8,69.5,336.4c0,131.2,88.5,241.4,208.3,272.6c30.2,7.9,62.2,7.9,92.3,0c113.8-22.9,208.3-133.4,208.3-272.6 C578.5,207.8,493.3,99.3,377,65.7z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M418,172.4c-57.2,1.6-103.1,52.8-103.1,111.6S360.4,393.4,418,395.7c57.2,0,103.1-52.8,103.1-111.6 S475.3,174,418,172.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M480.4,284.1c0-37.6-27.9-68-62.3-68c-34.4,0-62.3,30.5-62.3,68s27.9,68,62.3,68 C452.5,352.1,480.4,321.6,480.4,284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M439.2,220.2c-6.8-2.4-12.7-4-19.6-1.6c-23,8.1-39.8,34.3-39.8,65.4c0,31.7,17.5,58.3,41.2,65.9 c6,1.9,13.4-0.7,19.3-2.6c19.5-8.9,40.1-31.6,40.1-63.3C480.4,253,462.2,228.3,439.2,220.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M339.9,433c-30.5,0-55.1,26.9-55.1,58.3s24.3,58.1,55.1,58.1c31.1-1,55.1-26.7,55.1-58.1S370.5,434,339.9,433 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M361.1,491.4c0-12.8-9.5-23.1-21.2-23.1c-11.7,0-21.2,10.3-21.2,23.1c0,12.8,9.5,23.1,21.2,23.1 C351.6,514.5,361.1,504.1,361.1,491.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M348.2,470.2c-1.9-0.8-2-1.2-3.8-0.4c-6.3,2.7-10.9,11.4-10.9,21.7c0,10.5,4.8,19.3,11.3,21.8 c1.6,0.6,3.9-1.1,5.5-1.8c4.6-2.8,10.8-9.6,10.8-20.1C361.1,481.1,354.5,472.9,348.2,470.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000131339199447777419380000005988850319730172051_",
    d: "M369.5,67.2c-34-10.3-70.4-10.3-104.4,0 c-115.7,39.1-191,135-198.3,278.9C60,481.1,154,594.8,271.9,627c29.7,8.1,61.2,8.1,90.9,0c117.9-32.2,205-145.7,205-280.9 C567.8,213.6,484,101.8,369.5,67.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000099646488242724418980000005891832006030456209_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131339199447777419380000005988850319730172051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000099646488242724418980000005891832006030456209_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M172.6,115.5c-30.5,0-55.1,26.9-55.1,58.3s24.3,58.1,55.1,58.1c31.1-1,55.1-26.7,55.1-58.1 S203.2,116.5,172.6,115.5z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M193.8,173.9c0-12.8-9.5-23.1-21.2-23.1c-11.7,0-21.2,10.3-21.2,23.1s9.5,23.1,21.2,23.1 C184.3,197,193.8,186.6,193.8,173.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.9,152.7c-1.9-0.8-2-1.2-3.8-0.4c-6.3,2.7-10.9,11.4-10.9,21.7c0,10.5,4.8,19.3,11.3,21.8 c1.6,0.6,3.9-1.1,5.5-1.8c4.6-2.8,10.8-9.6,10.8-20.1C193.8,163.5,187.2,155.4,180.9,152.7z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M180,429.4c-12.7,0-23.8,11.4-23.8,25s10.5,24.8,23.8,24.8c13.6,0,23.8-11.2,23.8-24.8S192.9,429.4,180,429.4 z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M259.8,249.6c-12.7,0-23.8,11.4-23.8,25s10.5,24.8,23.8,24.8c13.6,0,23.8-11.2,23.8-24.8 S272.6,249.6,259.8,249.6z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M467.7,462.5c-12.7,0-23.8,11.4-23.8,25s10.5,24.8,23.8,24.8c13.6,0,23.8-11.2,23.8-24.8 S480.6,462.5,467.7,462.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoloToken);
export default __webpack_public_path__ + "static/media/yolo_token.146bd036e28419d6a2096e6f663f1505.svg";
export { ForwardRef as ReactComponent };